import moment from 'moment'

const dateOnly = value => {
  if (!value) return null
  const date = moment(value)
  return date.isValid() ? date.format('YYYY-MM-DD') : null
}

export const actionEndDateLimits = (claim, policy, today = moment().format('YYYY-MM-DD')) => {
  const start = dateOnly(claim?.claim_absence_start_date || claim?.start_date)
  const inception = dateOnly(policy?.policy_inception)
  const expiry = dateOnly(policy?.policy_expire)
  if (policy?.policy_status === 'previous') return { min: inception || start, max: today }
  return {
    min: [start, inception].filter(Boolean).sort().pop(),
    max: [today, expiry].filter(Boolean).sort()[0],
  }
}

export const documentDeadline = (claim, today = moment().format('YYYY-MM-DD')) => {
  const excluded = ['adoption leave', 'jury service', 'parental leave', 'maternity leave']
  if (!Number(claim?.can_expire) || !Number(claim?.claim_documents_requested) ||
    excluded.includes(String(claim?.condition || '').toLowerCase())) return null
  const requested = dateOnly(claim?.documents_requested_date)
  if (!requested) return null
  const deadline = moment(requested)
  let days = 0
  while (days < 30) {
    deadline.add(1, 'day')
    if (deadline.isoWeekday() <= 5) days += 1
  }
  return deadline.format('YYYY-MM-DD') >= today ? deadline.format('YYYY-MM-DD') : null
}
